import React from 'react';
import { LinkButton } from '@domain-group/fe-blueprint-ui/button';
import * as styles from './agent-awards.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentAwardOrMembership = _ref => {
  var awardOrMembership = _ref.awardOrMembership;
  return ___EmotionJSX("div", {
    css: styles.agentAward
  }, awardOrMembership.logoUrl && ___EmotionJSX("div", null, ___EmotionJSX("img", {
    src: awardOrMembership.logoUrl,
    alt: awardOrMembership.name,
    css: styles.agentAwardLogo
  })), ___EmotionJSX("div", {
    css: styles.agentAwardContent
  }, ___EmotionJSX("div", {
    css: styles.awardName
  }, awardOrMembership.name), ___EmotionJSX("div", {
    css: styles.awardDescription
  }, awardOrMembership.description), awardOrMembership.link && ___EmotionJSX(LinkButton, {
    href: awardOrMembership.link,
    css: styles.awardLink,
    target: "_blank",
    appearance: "link"
  }, "More info")));
};
export var AgentAwards = _ref2 => {
  var _ref2$memberships = _ref2.memberships,
    memberships = _ref2$memberships === void 0 ? [] : _ref2$memberships,
    _ref2$awards = _ref2.awards,
    awards = _ref2$awards === void 0 ? [] : _ref2$awards;
  return ___EmotionJSX("div", {
    css: styles.agentAwards
  }, memberships.length > 0 && ___EmotionJSX("div", {
    css: styles.agentAwardCategory
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, "Distinctions"), memberships.map(membership => ___EmotionJSX(AgentAwardOrMembership, {
    awardOrMembership: membership
  }))), awards.length > 0 && ___EmotionJSX("div", {
    css: styles.agentAwardCategory
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, "Awards"), awards.map(award => ___EmotionJSX(AgentAwardOrMembership, {
    awardOrMembership: award
  }))));
};